import React from 'react';
import { JcCommonProps, JcUtils } from '../utils/JcUtils';
import { useJcFieldId } from '../utils/useJcFieldId';

export interface JcDatePickerProps extends JcCommonProps {
    readonly value: string; // Date in ISO format (YYYY-MM-DD)
    readonly onChange: (value: string) => void;
    readonly min?: string; // Minimum date in ISO format
    readonly max?: string; // Maximum date in ISO format
    readonly disabled?: boolean;
    /** Accessible name for use outside a labelling JcField. */
    readonly ariaLabel?: string;
}

export const JcDatePicker: React.FunctionComponent<JcDatePickerProps> = (props: JcDatePickerProps) => {
    const id = useJcFieldId(props.id);
    const commonProps = JcUtils.commonProps({ ...props, id }, ["jc-input", "jc-datepicker"]);

    return (
        <input
            {...commonProps}
            aria-label={props.ariaLabel}
            type="date"
            value={props.value}
            min={props.min}
            max={props.max}
            disabled={props.disabled}
            onChange={e => props.onChange(e.target.value)}
        />
    );
};
